<template>
  <div class="connect-exchanges-content">
    <div class="connect-exchanges-content__description">
      <ConnectExchangesContentDescription
          title="Create an API key for Binance Spot"
          subtitle="Follow the steps below"
      />
    </div>
    <div class="connect-exchanges-content__instructions">
      <ConnectExchangesContentCreate v-if="displayCreate"  />
      <ConnectExchangesContentVerifySteps v-else-if="displayVerifySteps"  />
      <ConnectExchangesContentConnect
          v-else
          @connection-change="$emit('connection-change', $event)"
      />
    </div>
  </div>
</template>

<script>
import ConnectExchangesContentDescription from "@/components/ui/shared/modals/connect-exchanges/content/ConnectExchangesContentDescription";
import ConnectExchangesContentCreate from "@/components/ui/shared/modals/connect-exchanges/content/ConnectExchangesContentCreate";
import ConnectExchangesContentConnect from "@/components/ui/shared/modals/connect-exchanges/content/ConnectExchangesContentConnect";
import ConnectExchangesContentVerifySteps from "@/components/ui/shared/modals/connect-exchanges/content/ConnectExchangesContentVerifySteps";

export default {
  name: "ConnectExchangesContent",
  components: {
    ConnectExchangesContentVerifySteps,
    ConnectExchangesContentDescription,
    ConnectExchangesContentCreate,
    ConnectExchangesContentConnect,
  },
  props: {
    currentStep: {
      type: Number,
      default: 1
    }
  },
  computed: {
    displayCreate() {
      return this.currentStep === 1
    },
    displayVerifySteps() {
      return this.currentStep === 2
    }
  }
};
</script>

<style lang="scss" scoped>
.connect-exchanges-content {

  &__description {
    margin-bottom: 4rem;
  }

}
@media (max-width:768px) {
  .connect-exchanges-content {
    width: auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__instructions {
      width: 20.5rem;
    }
  }
}
</style>